import i18n from 'i18n';
import {
  ColDef,
} from '@ag-grid-community/core';
import { COMMON_GRID_COLUMN_FIELD_NAMES } from 'shared/commonGrid/grid-enums';

export enum ContactMenuActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view',
}

/**
 * This value must be set in common-grid columnDefsVersion property. So, updating this value
 * forces common-grid to use the in code columnDefs instead of the saved grid setting.
 */
export const contactColumnDefsVersion = '1';

export const contactColumnDefs: ColDef[] = [
  {
    headerName: '',
    field: COMMON_GRID_COLUMN_FIELD_NAMES.Action,
    cellRenderer: 'actionMenuCellRenderer',
  },
  {
    headerName: i18n.t('contact.grid.name'),
    field: 'name',
    tooltipField: 'name',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
  },
  {
    headerName: i18n.t('contact.grid.fullname'),
    field: 'fullname',
    tooltipField: 'fullname',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
  },
  {
    headerName: i18n.t('contact.grid.organization'),
    field: 'organization',
    tooltipField: 'organization',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
  },
  {
    headerName: i18n.t('contact.grid.phone'),
    field: 'phone',
    tooltipField: 'phone',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
    aggFunc: 'first',
  },
  {
    headerName: i18n.t('contact.grid.pager'),
    field: 'pager',
    tooltipField: 'pager',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
    aggFunc: 'first',
  },
  {
    headerName: i18n.t('contact.grid.mobile'),
    field: 'mobile',
    tooltipField: 'mobile',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
    aggFunc: 'first',
  },
  {
    headerName: i18n.t('contact.grid.fax'),
    field: 'fax',
    tooltipField: 'fax',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
    aggFunc: 'first',
  },
  {
    headerName: i18n.t('contact.grid.email'),
    field: 'email',
    tooltipField: 'email',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
    aggFunc: 'first',
  },
  {
    headerName: i18n.t('contact.grid.address'),
    field: 'address',
    tooltipField: 'address',
    sortable: true,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    resizable: true,
    flex: 1,
    minWidth: 240,
    aggFunc: 'first',
  },
];
